import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import {
  relayTransactionLogger,
  getMissingFieldHandlers,
  requiredFieldLogger,
} from '@woovi/relay';
import { APP_ENVIRONMENT_ENUM } from '@woovi/shared';

import cacheHandler from './cacheHandler.tsx';
import { subscribeFn } from './subscribeFn.tsx';


const isDev = process.env.NODE_ENV === APP_ENVIRONMENT_ENUM.DEVELOPMENT;

const source = new RecordSource();
const store = new Store(source, {
  // This property tells Relay to not immediately clear its cache when the user
  // navigates around the app. Relay will hold onto the specified number of
  // query results, allowing the user to return to recently visited pages
  // and reusing cached data if its available/fresh.
  gcReleaseBufferSize: 10,
});

const getEnvironmentLog = () => {
  if (isDev) {
    return {
      log: relayTransactionLogger,
    };
  }

  return {};
};

export const getEnv = (appID: string) => {
  const cacheHandlerAppID = cacheHandler(appID);
  const network = Network.create(cacheHandlerAppID, subscribeFn);

  const env = new Environment({
    network,
    store,
    ...getEnvironmentLog(),
    ...getMissingFieldHandlers(),
    relayFieldLogger: requiredFieldLogger,
  });

  return env;
};

// this is only used for mocking in tests
export const clearEnv = (): void => {};
